import type { TFunction } from 'i18next';

export type MusicStyle = {
  tag: string;
  label: string;
};

/** Canonical music style tags — English fallback labels; use getMusicStyleLabel() in UI. */
export const MUSIC_STYLES: MusicStyle[] = [
  { tag: 'rock', label: 'Rock' },
  { tag: 'pop', label: 'Pop' },
  { tag: 'blues', label: 'Blues' },
  { tag: 'jazz', label: 'Jazz' },
  { tag: 'french', label: 'Chanson Francaise' },
  { tag: 'ballad', label: 'Ballad' },
  { tag: 'metal', label: 'Metal' },
  { tag: 'folk', label: 'Folk' },
  { tag: 'funk', label: 'Funk' },
  { tag: 'punk', label: 'Punk' },
  { tag: 'grunge', label: 'Grunge' },
  { tag: 'bossa', label: 'Bossa' },
  { tag: 'classical', label: 'Classical' },
];

export const MUSIC_STYLE_TAGS = MUSIC_STYLES.map((style) => style.tag);

export function getMusicStyleLabel(tag: string, t: TFunction): string {
  const fallback = MUSIC_STYLES.find((style) => style.tag === tag)?.label ?? tag;
  return t(`musicStyles.tags.${tag}`, { defaultValue: fallback });
}
